import { createAction, props } from '@ngrx/store';

import { CreateDaigakuData, UpdateDaigakuData, Daigaku } from '../models/daigaku';
import { AppError } from '../errors/app-error';
import { DeleteDaigakuResponse } from '../models/delete-daigaku-response';

// findDaigaku ------------------------------------------------------------
export const findDaigaku = createAction('[Daigaku] Find Daigaku', props<{ daigakuId: string }>());
export const findDaigakuSuccess = createAction('[Daigaku] Find Daigaku Success', props<{ daigaku: Daigaku }>());
export const findDaigakuFailure = createAction('[Daigaku] Find Daigaku Failure');
export const initializeFindDaigakuState = createAction('[Daigaku] Initialize Find Daigaku State');

// findDaigakus ------------------------------------------------------------
export const findDaigakus = createAction(
  '[Daigaku] Find Daigakus',
  props<{ daigakuId?: string; daigakuCode?: string; daigakuName?: string; daigakuSubName?: string; prefectureId?: string }>()
);
export const findDaigakusSuccess = createAction('[Daigaku] Find Daigakus Success', props<{ daigakus: Daigaku[] }>());
export const findDaigakusFailure = createAction('[Daigaku] Find Daigakus Failure');
export const initializeFindDaigakusState = createAction('[Daigaku] Initialize Find Daigakus State');

export const createDaigaku = createAction('[Daigaku] Create Daigaku', props<{ daigaku: CreateDaigakuData }>());
export const createDaigakuSuccess = createAction('[Daigaku] Create Daigaku Success', props<{ daigaku: Daigaku }>());
export const createDaigakuFailure = createAction('[Daigaku] Create Daigaku Failure', props<{ error: AppError }>());
export const initializeCreateDaigakuState = createAction('[Daigaku] Initialize Crate Daigaku State');

export const updateDaigaku = createAction('[Daigaku] Update Daigaku', props<{ daigaku: UpdateDaigakuData }>());
export const updateDaigakuSuccess = createAction('[Daigaku] Update Daigaku Success', props<{ daigaku: Daigaku }>());
export const updateDaigakuFailure = createAction('[Daigaku] Update Daigaku Failure', props<{ error: AppError }>());
export const initializeUpdateDaigakuState = createAction('[Daigaku] Initialize Update Daigaku State');

export const deleteDaigaku = createAction('[Daigaku] Delete Daigaku', props<{ id: string }>());
export const deleteDaigakuSuccess = createAction('[Daigaku] Delete Daigaku Success', props<{ response: DeleteDaigakuResponse }>());
export const deleteDaigakuFailure = createAction('[Daigaku] Delete Daigaku Failure', props<{ error: AppError }>());
export const initializeDeleteDaigakuState = createAction('[Daigaku] Initialize Delete Daigaku State');
